import React, { useState } from 'react';
import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { auth, registrarActividad } from '../firebase';
import useEsMovil from '../hooks/useEsMovil';
import Header from './Header';

// Pedido de Mica (2026-09-29): aunque la sesión esté abierta, para ver una
// pantalla con plata (Proveedores) hay que volver a poner la contraseña. Se
// pide cada vez que se entra a la pantalla: el desbloqueo vive solo mientras
// la pantalla está abierta.
function PedirContrasena({ titulo, seccion, sinEncabezado, children }) {
  const esMovil = useEsMovil();
  // El desbloqueo sobrevive a actualizar la página (pedido de Mica,
  // 2026-10-08: al refrescar parecía que se cerraba la sesión porque volvía a
  // pedir la contraseña). Dura 30 minutos en esta pestaña; al cerrarla se pierde.
  const claveDesbloqueo = `desbloqueo_${seccion || titulo}`;
  const [desbloqueado, setDesbloqueado] = useState(() => {
    try { return Number(sessionStorage.getItem(claveDesbloqueo)) > Date.now(); } catch (_) { return false; }
  });
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [verificando, setVerificando] = useState(false);

  if (desbloqueado) return children;

  const verificar = async (e) => {
    e.preventDefault();
    if (!password) return;
    setError('');
    setVerificando(true);
    try {
      const credencial = EmailAuthProvider.credential(auth.currentUser.email, password);
      await reauthenticateWithCredential(auth.currentUser, credencial);
      await registrarActividad('Desbloqueó pantalla con contraseña', seccion);
      try { sessionStorage.setItem(claveDesbloqueo, String(Date.now() + 30 * 60 * 1000)); } catch (_) { /* sin storage */ }
      setDesbloqueado(true);
    } catch (err) {
      if (err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setError('La contraseña no es correcta.');
        await registrarActividad('Contraseña incorrecta al desbloquear pantalla', seccion);
      } else if (err.code === 'auth/too-many-requests') {
        setError('Demasiados intentos. Esperá unos minutos y probá de nuevo.');
      } else {
        setError('No se pudo verificar. Intentá de nuevo.');
      }
      setPassword('');
    } finally {
      setVerificando(false);
    }
  };

  return (
    // sinEncabezado: para usarlo dentro de una pestaña de otra pantalla (ej.
    // Pagos Flex dentro de Envíos), que ya tiene su propio encabezado.
    <div style={sinEncabezado ? {} : { minHeight: '100vh', background: 'var(--tu-bg)' }}>
      {!sinEncabezado && <Header titulo={titulo} />}
      <div style={{ display: 'flex', justifyContent: 'center', padding: sinEncabezado ? '16px' : (esMovil ? '24px 16px' : '48px 16px') }}>
        <form
          onSubmit={verificar}
          style={{
            background: 'white', padding: esMovil ? '20px' : '28px', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
            width: '100%', maxWidth: '360px', boxSizing: 'border-box', textAlign: 'center',
          }}
        >
          <div style={{ fontSize: '32px' }}>🔒</div>
          <h3 style={{ margin: '8px 0 4px' }}>Acceso restringido</h3>
          <p style={{ fontSize: '13px', color: '#666', marginTop: 0 }}>Contraseña</p>
          <input
            type="password" autoFocus value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Tu contraseña"
            style={{
              width: '100%', padding: '10px', border: '2px solid #eee', borderRadius: '8px',
              boxSizing: 'border-box', fontSize: '15px', marginTop: '8px',
            }}
          />
          {error && <p style={{ color: '#E4212C', fontSize: '13px', margin: '8px 0 0' }}>{error}</p>}
          <button
            type="submit" disabled={verificando || !password}
            style={{
              width: '100%', marginTop: '14px', padding: esMovil ? '12px 20px' : '10px 20px', background: '#E4212C', color: 'white',
              border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px',
            }}
          >
            {verificando ? 'Verificando...' : 'Ver'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default PedirContrasena;
